<div class="card new-card">
    <app-card-title title="Dados do proprietário" icon="material-icons" iconBody="person"></app-card-title>
    <div class="info-container">
        <div class="info">
          <div class="label-container">
            <span class="label">Nome</span>
          </div>
          <span class="value">{{vehicle?.owner?.name || '-'}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">CPF/CNPJ</span>
          </div>
          <span class="value">{{vehicle?.owner?.cpfLabel || '-'}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">Email</span>
          </div>
          <span class="value">{{vehicle?.owner?.email || '-'}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">Telefone</span>
          </div>
          <span class="value">{{vehicle?.owner?.phoneNumber || '-'}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">Expectativa de preço</span>
          </div>
          <span class="value">{{(vehicle?.expectedPrice | currency: 'BRL' : 'symbol' : '1.2-2') || '-'}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">Motivação</span>
          </div>
          <span class="value">{{evalReasonLabel}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">Veículo de interesse</span>
          </div>
          <span class="value">{{vehicle?.interestedAt || vehicle?.numberPlateOfInterest || '-'}}</span>
        </div>
      </div>
</div>